import React, { useState } from 'react';
import ConfirmButton from './components/ConfirmButton';
import ChoiceButton from './components/ChoiceButton';
import NutritionChoiceButton from './components/NutritionChoiceButton';
import WaterChoiceButton from './components/WaterChoiceButton';
import SleepChoiceButton from './components/SleepChoiceButton';
import QuestionCard from './components/QuestionCard';
import QuestionText from './components/QuestionText';
import AssessmentSection from './components/AssessmentSection';
import assessmentImage from './images';

const TestComponent = () => {

  const [choice, setChoice] = useState('A');
  const [waterChoice, setWaterChoice] = useState('A');
  const [sleepChoice, setSleepChoice] = useState('A');

  return (
    <div style={{
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }}>

      <AssessmentSection image={assessmentImage.nutritionSection} text={'คำถามคุณภาพโภชนาการ'} count={5} />
      <AssessmentSection image={assessmentImage.waterSection} text={'คำถามการดื่มน้ำ'} count={2} />
      <AssessmentSection image={assessmentImage.sleepSection} text={'คำถามการนอนหลับ'} count={3} />
      <ConfirmButton text='ยืนยันคำตอบ' width={'100%'} onClick={() => { }} />
      <ConfirmButton disabled text='ยืนยันคำตอบ (disabled)' width={'100%'} onClick={() => { }} />

      {/* Nutrition (orange) */}
      <QuestionCard>
        <QuestionText>1.1 คำถามโภชนาการ (NutritionChoiceButton)</QuestionText>
        <NutritionChoiceButton active={choice === 'A'} choiceLabel='A' choiceText='Sunt nisi sit consequat quis commodo dolor.' onClick={() => setChoice('A')} />
        <NutritionChoiceButton active={choice === 'B'} choiceLabel='B' choiceText='ตัวอย่างคำตอบ (B)' onClick={() => setChoice('B')} />
        <NutritionChoiceButton active={choice === 'C'} choiceLabel='C' choiceText='ตัวอย่างคำตอบ (C)' onClick={() => setChoice('C')} />
        <NutritionChoiceButton active={choice === 'D'} choiceLabel='D' choiceText='ตัวอย่างคำตอบ (D)' onClick={() => setChoice('D')} />
      </QuestionCard>

      {/* Water (blue) */}
      <QuestionCard>
        <QuestionText>2.1 คำถามการดื่มน้ำ (WaterChoiceButton)</QuestionText>
        <WaterChoiceButton active={waterChoice === 'A'} choiceLabel='A' choiceText='ดื่มน้ำ 8 แก้วต่อวัน' onClick={() => setWaterChoice('A')} />
        <WaterChoiceButton active={waterChoice === 'B'} choiceLabel='B' choiceText='ดื่มน้ำ 5-7 แก้วต่อวัน' onClick={() => setWaterChoice('B')} />
        <WaterChoiceButton active={waterChoice === 'C'} choiceLabel='C' choiceText='ดื่มน้ำ 3-4 แก้วต่อวัน' onClick={() => setWaterChoice('C')} />
        <WaterChoiceButton active={waterChoice === 'D'} choiceLabel='D' choiceText='ดื่มน้ำน้อยกว่า 3 แก้วต่อวัน' onClick={() => setWaterChoice('D')} />
      </QuestionCard>

      {/* Sleep (purple) */}
      <QuestionCard>
        <QuestionText>3.1 คำถามการนอนหลับ (SleepChoiceButton)</QuestionText>
        <SleepChoiceButton active={sleepChoice === 'A'} choiceLabel='A' choiceText='นอนหลับ 7-8 ชั่วโมงต่อวัน' onClick={() => setSleepChoice('A')} />
        <SleepChoiceButton active={sleepChoice === 'B'} choiceLabel='B' choiceText='นอนหลับ 5-6 ชั่วโมงต่อวัน' onClick={() => setSleepChoice('B')} />
        <SleepChoiceButton active={sleepChoice === 'C'} choiceLabel='C' choiceText='นอนหลับน้อยกว่า 5 ชั่วโมงต่อวัน' onClick={() => setSleepChoice('C')} />
        <SleepChoiceButton active={sleepChoice === 'D'} choiceLabel='D' choiceText='นอนไม่หลับบ่อยครั้ง' onClick={() => setSleepChoice('D')} />
      </QuestionCard>
    </div>
  );
};

export default TestComponent;
